import {fork} from 'redux-saga/effects';

import {sagas as leadInvite} from './invite';
import {sagas as leadDeal} from './deal';

export function* sagas() {
  yield fork(leadInvite);
  yield fork(leadDeal);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/lead/index.js